export function collectGroupIds (items, ids = []) {
  if (!Array.isArray(items)) return ids

  items.forEach(item => {
    if (Array.isArray(item.child) && item.child.length > 0) {
      ids.push(item.id)
      collectGroupIds(item.child, ids)
    }
  })

  return ids
}

export function flattenTreeRows (items, collapsed = [], depth = 0) {
  if (!Array.isArray(items)) return []

  const rows = []

  items.forEach(item => {
    const hasChildren = Array.isArray(item.child) && item.child.length > 0
    const isCollapsed = collapsed.indexOf(item.id) !== -1

    rows.push({
      id: item.id,
      item,
      depth,
      kind: hasChildren ? 'group' : 'detail',
      collapsed: isCollapsed
    })

    if (hasChildren && !isCollapsed) {
      rows.push(...flattenTreeRows(item.child, collapsed, depth + 1))
    }
  })

  return rows
}
